import { useMemo, useState } from 'react';

import SurveyReminder from '@crehana/web/components/SurveyReminder';

import { LEARN_DASHBOARD_PAGE_NAME } from '../../../../constants';
import {
  useNPSSurveyValidation,
  useValidateAndUpdateCurrentNotification,
} from '../../hooks';
import { CurrentNotification } from '../../hooks/useValidateAndUpdateCurrentNotification';
import { PAYGNotificationKey } from '../../types';

const PAYGNotification = () => {
  const [currentNotification, setCurrentNotification] =
    useState<CurrentNotification<PAYGNotificationKey>>();

  const npsSurveyValidation = useNPSSurveyValidation({
    currentNotificationIndex: currentNotification?.index,
    notificationType: 'payg',
  });

  const validationsByNotificationKey: Record<PAYGNotificationKey, boolean> =
    useMemo(
      () => ({
        'nps-reminder': npsSurveyValidation.isActiveOrBeingEvaluated,
      }),
      [npsSurveyValidation.isActiveOrBeingEvaluated],
    );

  useValidateAndUpdateCurrentNotification({
    currentNotification,
    setCurrentNotification,
    validationsByNotificationKey,
    notificationsType: 'payg',
  });

  if (currentNotification?.isActiveOrBeingEvaluated) {
    switch (currentNotification.key) {
      case 'nps-reminder':
        return npsSurveyValidation.isEnabledToShow ? (
          <SurveyReminder
            surveyId={npsSurveyValidation.surveyId}
            amplitudePageName={LEARN_DASHBOARD_PAGE_NAME}
          />
        ) : null;
      default:
        return null;
    }
  }
  return null;
};

export default PAYGNotification;
